import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimEntitlementAutoTopUpJobRoleFilterContainerModel
} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimEntitlementAutoTopUpJobRoleFilterService extends BaseApiTemplateService<ClaimEntitlementAutoTopUpJobRoleFilterContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/backoffice-ep';
    this.httpClient = http;
  }

  postMultipleFilter(body: ClaimEntitlementAutoTopUpJobRoleFilterContainerModel[], visa: ApiVisa):
    Observable<ApiResponseModel<ClaimEntitlementAutoTopUpJobRoleFilterContainerModel>>  {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/multiple/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/multiple/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<ClaimEntitlementAutoTopUpJobRoleFilterContainerModel>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

  getJobRoles(visa: ApiVisa): Observable<ApiResponseModel<string[]>>  {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/public/distinct-job-roles/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-templates/filter-job-roles/public/distinct-job-roles/backoffice-ep';
    }

    return this.httpClient.get<ApiResponseModel<string[]>>(url, this.getHttpHeader(visa));
  }

}


